var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-directions-walk"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M6.63614 14.9806L6.61649 3.54057C6.61619 3.36769 6.82056 3.27593 6.94959 3.391L13.4084 9.15093C13.4979 9.23075 13.4975 9.37085 13.4076 9.45018L6.96846 15.1303C6.83944 15.2441 6.63644 15.1527 6.63614 14.9806Z",
    fill: "#1746C2",
    stroke: "#1746C2",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.252fd4f7bd19915bca654e3ae7bbe4a2.svg";
export { ForwardRef as ReactComponent };